<template>
  <v-form>
    <br />
    <v-layout row wrap>
      <v-flex xs12 sm12 class="col-padd">
        <v-text-field
          v-model="indicador.punto.nombre"
          label="Punto:"
          :readonly="true"
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm12 class="col-padd">
        <v-textarea
          v-model="indicador.pilar.nombre"
          label="Pilar:"
          :readonly="true"
        ></v-textarea>
      </v-flex>

      <v-flex xs12 sm12 class="col-padd">
        <v-text-field
          v-model="indicador.estrategia.nombre"
          label="Estrategia:"
          :readonly="true"
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm12 class="col-padd">
        <v-textarea
          v-model="indicador.linea.nombre"
          label="Línea de acción:"
          :readonly="true"
        ></v-textarea>
      </v-flex>

      <v-flex xs12 sm12 class="col-padd">
        <v-textarea
          v-model="indicador.idproductoNavigation.nombre"
          label="Producto:"
          :readonly="true"
        ></v-textarea>
      </v-flex>

      <v-flex xs12 sm12 class="col-padd">
        <v-text-field
          v-model="indicador.codigo"
          label="Código del indicador:"
          :readonly="true"
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm12 v-if="indicador !== null" class="col-padd">
        <v-textarea
          v-model="indicador.nombre"
          label="Indicador:"
          :readonly="true"
        ></v-textarea>
      </v-flex>

      <v-flex xs12 sm6 class="col-padd">
        <v-text-field
          v-model="indicador.inicio"
          label="Fecha inicio:"
          :readonly="true"
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm6>
        <v-text-field
          v-model="indicador.fin"
          label="Fecha fin:"
          :readonly="true"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm6>
        <v-select
          label="Sector:"
          item-text="nombre"
          :no-data-text="gnodata"
          :items="gsectores"
          return-object
          v-model="sector"
          :readonly="!administrar"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm6 v-if="entidades != null">
        <v-select
          label="Entidad responsable:"
          item-text="nombre"
          :no-data-text="gnodata"
          :items="entidades"
          return-object
          v-model="entidad"
          :readonly="!administrar"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm12 class="col-padd">
        <v-text-field
          v-model="indicador.idclasificacionNavigation.nombre"
          label="Clasificador PMI:"
          :readonly="true"
        ></v-text-field>
      </v-flex>
      <v-divider></v-divider>
      
      <v-flex xs12 sm6>
        <v-select
          :items="gtiposclasificador"
          v-model="itemsclasificacion"
          item-text="nombre"
          item-value="idtipoclasificador"
          label="Instrumento de planeación"
          :readonly="!administrar"
          multiple
        ></v-select>
      </v-flex>
      <v-flex xs12 sm6 v-show="permitenacional">
        <v-select
          :items="gnacionales"
          v-model="indicador.idnacional"
          item-text="nombre"
          item-value="idnacional"
          label="Plan nacional"
          :readonly="!administrar"
        ></v-select>
      </v-flex>
    </v-layout>
  </v-form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "indicador_basicos",
  data: function () {
    return {
      permitenacional: false,
      itemsclasificacion: null,
      indicador: null,
      sector: null,
      entidad: null,
      entidades: []
    };
  },
  created() {
    if (this.gsectores.length == 0)
      this.get_sectores();

    this.itemsclasificacion = this.gficha_itemsclasificacion;
    this.indicador = this.gficha_indicador;   
    if (this.indicador.entidades !== undefined) {        

      let temp = this.gentidades.filter(
        (p) => p.identidad === this.indicador.entidades.identidad
      )[0];
      if (this.gsectores.length > 0)
        this.sector = this.gsectores.filter(
          (p) => p.idsector === temp.idsector
        )[0];  
      this.entidad = temp;
    }
  },
  watch: {
    entidad:  function () {  
        this.indicador.entidades = this.entidad;        
        this.set_indicador({ indicador: this.indicador });
    },
    sector:  function () {  
        if (this.sector != undefined)
          this.entidades = this.gentidades.filter(p=> p.idsector === this.sector.idsector );                
    }
    ,
    indicador: function () {
      this.set_indicador({ indicador: this.indicador });
    },
    itemsclasificacion: function () {
      if (this.itemsclasificacion.length > 0) {
        this.permitenacional = false;
        this.gtiposclasificador.forEach((element) => {
          let clasificadorFiltrado = this.itemsclasificacion.filter(function (
            params
          ) {
            return params == element.idtipoclasificador;
          });
          if (clasificadorFiltrado.length > 0)
            if (element.manejanacional != null)
              if (element.manejanacional == true) {
                this.permitenacional = true;
              }
        });
      } else {
        this.permitenacional = false;
      }
      if (this.permitenacional == false) {
        if (this.indicador.idnacional != null) this.indicador.idnacional = null;
      }
      this.set_itemsclasificacion({
        itemsclasificacion: this.itemsclasificacion,
      });
    },
    gficha_indicador: function () {
      this.indicador = this.gficha_indicador;   
      if (this.indicador.entidades !== undefined) {        
        let temp = this.gentidades.filter(
          (p) => p.identidad === this.indicador.entidades.identidad
        )[0];
        this.sector = this.gsectores.filter(
          (p) => p.idsector === temp.idsector
        )[0];      
        this.entidad = temp;
      }
    },
    gsectores: function () {
      let temp = this.entidad
      if (this.gsectores.length > 0)
      {
        if (temp != undefined)
          this.sector = this.gsectores.filter(
            (p) => p.idsector === temp.idsector
          )[0];  
      }
    }
  },
  props: {
    administrar: {
      required: true,
      type: Boolean,
    },
  },
  methods: {
    ...mapActions([
      "get_sectores"
        ]),
    ...mapActions("fichatecnica/", [
      "set_permitenacional",
      "set_itemsclasificacion",
      "set_indicador"
    ]),
  },
  computed: {
    ...mapGetters([
      "gtiposclasificador",
      "gnacionales",
      "gentidades",
      "gsectores",
    ]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    ...mapGetters("fichatecnica", [
      "gficha_permitenacional",
      "gficha_itemsclasificacion",
      "gficha_indicador",
    ]),
  },
};
</script>